import { request } from './client'

/* **W-131 + W-133 — WHAT THIS SERVER CAN DO, AND WHAT THE LOG IS ABOUT TO FORGET.**
   Sprint 70.

   Every fact here already existed in a start-up log nobody in the hotel reads, and the
   consequence was the same each time: a thing that quietly does not work looks exactly
   like a thing that works until somebody needs it. */

/** **THREE STATES AND NOT TWO.** `PREVIEW` is the one that matters — a two-state screen
 *  would have to round it to green, which is how a hotel goes live on a stub. */
export type HealthState = 'OK' | 'PREVIEW' | 'MISSING'

export interface HealthCheck {
  code: string
  state: HealthState
  /** **A CODE, NEVER A SENTENCE.** The server's first draft sent finished English prose
   *  here, which would have drawn an English sentence down the middle of the Arabic screen
   *  — the shape of #74, #82, #83 and #102, and invisible to the dictionary guard because
   *  it arrives as data. The codes are checked in at `app/contracts/system-health.json`. */
  note: string | null
  /** The raw technical fact behind the note — a provider's name, a row count, an exception
   *  type. Drawn left-to-right verbatim in both languages, as the version string is. */
  value: string | null
}

export interface RetentionView {
  months: number
  cutOffUtc: string
  /** **Null when the log is empty** — which is not "nothing has been deleted". */
  oldestEntryUtc: string | null
  entriesHeld: number
  /** Rows that fall outside the window in the next thirty days. */
  expiringWithinMonth: number
}

export interface SystemHealthView {
  environment: string
  version: string
  serverTimeUtc: string
  propertyTimeZone: string
  propertyLocalDate: string
  checks: HealthCheck[]
  /** What is owed from outside this product before it can be deployed. Named, not counted. */
  blockedOn: string[]
  retention: RetentionView
}

export const fetchSystemHealth = (
  propertyId: string, options: { signal?: AbortSignal } = {},
) => request<SystemHealthView>(
  `/properties/${propertyId}/system`,
  options.signal ? { signal: options.signal } : {})
